import axios from "axios";
// Entities
import { PiecesInStock } from "@/entities/index";

export async function getPiecesInStock({
  client,
  warehouse,
  integrateStepZero,
  optionPalette,
}: {
  client: string;
  warehouse: string;
  integrateStepZero: boolean;
  optionPalette: boolean;
}): Promise<{ piecesInStock: number[]; total: number; totalPallet: number }> {
  const { piecesInStock, total, totalPallet } = (
    await axios.post(`/api/dashboards/chart1`, {
      client,
      warehouse,
      integrateStepZero,
      optionPalette,
    })
  ).data as PiecesInStock;

  return { piecesInStock, total, totalPallet };
}
